module.exports = __webpack_public_path__ + "img/logo-sm-light.1393f806.png";